import React from "react";

export const Loading: React.FC = () => {
  return (
    <div className="flex items-center justify-center">
      <div
        className="h-8 w-8 border-2 border-gray-300 border-t-transparent rounded-full animate-spin"
        role="status"
        aria-label="Loading"
      />
    </div>
  );
};

export default Loading;
